export default "__VITE_ASSET__fc27e6d7__"